
export default {
    name: 'SvgLights',
    props: {
        color: {
            type: String,
            default: '#615F5A',
        },
    },
};
